import strings from 'localization/strings';

const storageSiteBookingUpdateModes = {
    noBookings: {},
    someActiveSubscriptionBookings: {},
    allActiveSubscriptionBookings: {}
};
Object.keys(storageSiteBookingUpdateModes).forEach(key => {
    storageSiteBookingUpdateModes[key].key = key;
});

strings.addLoadCallback(() => {
    Object.values(storageSiteBookingUpdateModes).forEach(o => {
        o.title = strings.storageSiteBookingUpdateModes[o.key];
    });
});

export default storageSiteBookingUpdateModes;
